/*!
 * recozy – Variantenbild-Synchronisation für Kalles (T4S)  ·  v6
 * ---------------------------------------------------------------------------
 * Aufgabenteilung:
 *   SERVER (sections/main-product.liquid)
 *     - blendet alle Variantenbilder bis auf einen Platz aus ("is--media-hide")
 *     - rendert in diesem Platz direkt das Bild der AKTUELLEN Variante
 *     -> die Seite ist schon ohne JavaScript korrekt, und Flickity sieht die
 *        ausgeblendeten Zellen nie (kein Cache-Rennen moeglich)
 *   DIESES SCRIPT
 *     - tauscht beim Farbwechsel nur noch das Bild in diesem Platz
 *
 * v5 – Robustheit:
 *   - Der change-Listener haengt am document (Delegation, capture) statt am
 *     konkreten <select>. Rendert das Theme den Produktbereich neu, waere ein
 *     direkt gebundener Listener verloren gewesen.
 *   - Zustand haengt am Galerie-Element, nicht in einer Closure.
 *   - Keine Slider-Aufrufe, damit nichts mit dem Theme-Handler kollidiert.
 *
 * Die Zuordnung Farbe -> Bild kommt aus Shopifys Variantendaten
 * (<option data-mdid="...">), nicht aus Dateinamen.
 */
(function () {
  'use strict';

  var WIDTHS = [200, 400, 600, 800, 1000, 1200, 1400, 1600];
  var DEFAULT_W = 1000;

  function withWidth(m, w) { return m ? m + (m.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : ''; }
  function srcset(m) { return WIDTHS.map(function (w) { return withWidth(m, w) + ' ' + w + 'w'; }).join(', '); }

  function midOf(opt) {
    var raw = opt.getAttribute('data-mdid');
    if (!raw) return null;
    raw = raw.replace(/"/g, '').trim();
    return raw && raw !== 'null' && raw !== '0' ? raw : null;
  }

  /* Originalzustand aller Variantenbilder einmalig sichern und am
     Galerie-Element ablegen. Muss vor dem ersten Tausch passieren. */
  function storeFor(gallery, isVariantMedia) {
    if (gallery.__rzStore) return gallery.__rzStore;
    var store = {};
    var slides = gallery.querySelectorAll('[data-main-slide][data-media-id]');
    Array.prototype.forEach.call(slides, function (el) {
      var id = el.getAttribute('data-media-id');
      if (!isVariantMedia[id] || store[id]) return;
      var img = el.querySelector('img');
      if (!img) return;
      var wrap = el.querySelector('.t4s-product__media');
      store[id] = {
        master: img.getAttribute('data-master') || '',
        alt: img.getAttribute('alt') || '',
        width: img.getAttribute('width'),
        height: img.getAttribute('height'),
        ratio: wrap ? wrap.style.getPropertyValue('--aspect-ratioapt') : '',
        maxw: wrap ? wrap.style.getPropertyValue('--mw-media') : ''
      };
    });
    gallery.__rzStore = store;
    return store;
  }

  function apply(slide, d, mediaId) {
    var img = slide.querySelector('img');
    if (!img || !d || !d.master) return;
    slide.setAttribute('data-media-id', mediaId);
    var wrap = slide.querySelector('.t4s-product__media');
    if (wrap) {
      if (d.ratio) wrap.style.setProperty('--aspect-ratioapt', d.ratio);
      if (d.maxw) wrap.style.setProperty('--mw-media', d.maxw);
    }
    img.setAttribute('data-master', d.master);
    img.setAttribute('data-src', withWidth(d.master, DEFAULT_W));
    if (d.alt) img.setAttribute('alt', d.alt);
    if (d.width) img.setAttribute('width', d.width);
    if (d.height) img.setAttribute('height', d.height);
    // Immer direkt setzen: lazysizes fasst ein bereits verarbeitetes <img>
    // nicht erneut an, sonst bliebe das alte Bild stehen.
    //
    // ENTSCHEIDEND: Auch data-srcset schreiben. Bei gesetztem srcset ignoriert
    // der Browser src vollstaendig, und der Lazyloader (Klasse ls-is-cached)
    // schreibt srcset aus seinem eigenen data-srcset zurueck. Ohne diese Zeile
    // zeigte die Seite weiter das alte Bild, obwohl src bereits korrekt war.
    var ss = srcset(d.master);
    img.setAttribute('data-srcset', ss);
    img.setAttribute('srcset', ss);
    img.setAttribute('src', withWidth(d.master, DEFAULT_W));
  }

  function handle(select) {
    var scope = select.closest ? select.closest('[data-product-featured]') : null;
    if (!scope) return;
    var gallery = scope.querySelector('[data-main-media]');
    if (!gallery) return;

    var variantToMedia = {}, isVariantMedia = {};
    Array.prototype.forEach.call(select.options, function (o) {
      var mid = midOf(o);
      if (!mid) return;
      variantToMedia[String(o.value)] = mid;
      isVariantMedia[mid] = true;
    });

    var store = storeFor(gallery, isVariantMedia);
    var target = variantToMedia[String(select.value)];
    if (!target || !store[target]) return;

    // sichtbarer Variantenplatz – vom Server bestimmt
    var slot = null;
    var slides = gallery.querySelectorAll('[data-main-slide][data-media-id]');
    for (var i = 0; i < slides.length; i++) {
      var el = slides[i];
      if (el.classList.contains('is--media-hide')) continue;
      if (isVariantMedia[el.getAttribute('data-media-id')] || el.__rzSlot) { slot = el; break; }
    }
    if (!slot) return;
    slot.__rzSlot = true;                       // Platz merken, auch nach dem Tausch

    if (slot.getAttribute('data-media-id') === target) return;
    apply(slot, store[target], target);
  }

  // Delegiert am document: ueberlebt ein Neu-Rendern des Produktbereichs.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.tagName === 'SELECT' && t.getAttribute('name') === 'id') handle(t);
  }, true);

  function boot() {
    var sels = document.querySelectorAll('[data-product-featured] select[name="id"]');
    Array.prototype.forEach.call(sels, handle);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
